import { Skeleton, Stack, Typography } from '@mui/material';
import { Component } from 'react';
import { MdBuild, MdCheckCircle, MdOutlineCalculate, MdTrendingDown, MdTrendingUp, MdWarning } from 'react-icons/md';

export default class ApuracaoItensAjustados extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { loading, dados } = this.props;

        return (
            <>
                {loading ? <Skeleton height={182} variant="rounded" /> :
                    <Stack bgcolor="#f5f7fa" borderRadius={2} overflow={'hidden'}>
                        <Stack direction="row" bgcolor="#ebf1fa" height={40} color="#0A57A3" alignItems="center" gap={1} p={1.2}>
                            <MdBuild />
                            <Typography variant="caption"><b>Itens ajustados (112 + 302)</b></Typography>
                        </Stack>
                        <Stack p={2} direction="row" gap={2}>
                            <Stack bgcolor="#fef2f2" color="#b91c1c" borderRadius={2} border="1px solid #e5e7eb" p={2} gap={1} flex={1}>
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <MdTrendingDown size={12} />
                                    <Typography fontSize={10}><b>FALTAS</b></Typography>
                                </Stack>
                                <Typography fontSize={20}><b>{dados?.itensFalta}</b></Typography>
                                <Typography fontSize={12}>itens</Typography>
                            </Stack>

                            <Stack bgcolor="#f0fdf4" color="#15803d" borderRadius={2} border="1px solid #e5e7eb" p={2} gap={1} flex={1}>
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <MdTrendingUp size={12} />
                                    <Typography fontSize={10}><b>SOBRAS</b></Typography>
                                </Stack>
                                <Typography fontSize={20}><b>{dados?.itensSobra}</b></Typography>
                                <Typography fontSize={12}>itens</Typography>
                            </Stack>

                            <Stack bgcolor="#f8f9fa" color="#136188" borderRadius={2} border="1px solid #e5e7eb" p={2} gap={0.5} flex={1}>
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <MdOutlineCalculate size={12} />
                                    <Typography fontSize={10}><b>TOTAL</b></Typography>
                                </Stack>
                                <Typography fontSize={20}><b>{dados?.itensTotal}</b></Typography>
                                <Stack direction="row" alignItems="center" gap={0.7} flexWrap="wrap">
                                    <Typography fontSize={12}>itens</Typography>
                                    <Typography fontSize={10} color="#6b7a92">Meta: {dados?.metaTotal} itens</Typography>
                                    <Stack direction="row" alignItems="center" gap={0.3} color={dados?.acimaMeta ? '#b40909' : '#15803d'}>
                                        {dados?.acimaMeta ? <MdWarning size={12} /> : <MdCheckCircle size={12} />}
                                        <Typography fontSize={10}>{dados?.acimaMeta ? 'Acima da meta' : 'Dentro da meta'}</Typography>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>
                }
            </>
        );
    }
}
